import { render, staticRenderFns } from "./RoomCallAudio.vue?vue&type=template&id=be323180&scoped=true&"
import script from "./RoomCallAudio.vue?vue&type=script&lang=js&"
export * from "./RoomCallAudio.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallAudio.vue?vue&type=style&index=0&id=be323180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be323180",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be323180')) {
      api.createRecord('be323180', component.options)
    } else {
      api.reload('be323180', component.options)
    }
    module.hot.accept("./RoomCallAudio.vue?vue&type=template&id=be323180&scoped=true&", function () {
      api.rerender('be323180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/RoomCallAudio.vue"
export default component.exports